import SetupHikProtocolVersionSmsModal from './setup-hik-protocol-version-sms-modal.vue'
export default SetupHikProtocolVersionSmsModal
